import { useEffect, useState } from 'react'

import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { history } from 'services/history.js'

import { getImageUrl } from '../util/images'
import { getAuctionStatus } from '../util/dateString'

import css from './sass/adminauction.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import AuctionStatusAlert from './AuctionStatusAlert'
import PreviewPublishChecklist from './PreviewPublishChecklist'

export default function AuctionCard(props) {

  const auction = props.auction
  
  const [bannerUrl, setBannerUrl] = useState()
  
  const liveStatus = getAuctionStatus(auction?.StartTime, auction?.EndTime)

  //set auction kind to silent for now - paddle to come later
  let kind = 'silent'

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, 'banner', auction?.BannerImageName)
    setBannerUrl(url)
  }, [auction])

  const displayDate = (strDate) => {
    if (strDate) return new Date(strDate).toLocaleString()
    else return 'N/A'
  }

  let auctionKindElement = <></>
  if (kind === 'silent') auctionKindElement = <p className={css['auction-status-kind']}>SILENT AUCTION</p>
  if (kind === 'paddle') auctionKindElement = <p className={css['auction-status-kind']}>PADDLE AUCTION</p>

  return (
    <div className={css['auction-card-container']}>
      <img className={css['auction-card-grid-image']} src={`${bannerUrl}`} alt={`${auction.Title} banner`} />
      <div className={css['auction-card-grid-status']}>
        {auctionKindElement}
        <AuctionStatusAlert liveStatus={liveStatus} auctionStatus={auction.Status} />
      </div>
      {auction.Status === 'PREVIEW' ?
        <h3 className={css['auction-card-grid-title-preview']}>{auction.Title}</h3> :
        <button className={`${css['auction-card-grid-title']} ${themeCss['auction-title-link']}`}
          onClick ={(e) => {history.push({
            pathname: '/auctionhome',
            search: `?auctionId=${auction.AuctionCode}`,
          })}}>{auction?.Title}
        </button>
    }        

      <div className={css['auction-card-info']}>
        <p>Start Time</p>
        <p>{displayDate(auction.StartTime)}</p>
      </div>

      <div className={css['auction-card-info']}>
        <p>End Time</p>
        <p>{displayDate(auction.EndTime)}</p>
      </div>

      <div className={css['auction-card-info']}>
        <p># of Items</p>
        <p>{auction.Items?.length + auction.FixedItems?.length}</p>
      </div>

      <div className={css['auction-card-info']}>
        <Link className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
          to={`/admin/auctiondetail?auctionId=${auction.AuctionCode}`}>
          Manage Auction
        </Link>
      
      </div>
      <div className={css['auction-card-grid-checklist']}>
        <PreviewPublishChecklist liveStatus={liveStatus} auctionDetail={auction} location={'card'} />
      </div>
    </div>
  )
}